import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {   IContact, IEngineer, IOptions, IOptionSets } from '@ebb-v2/ebb-integration';

import {  IContactInput } from '@ebb-v2/ebb-integration'
import { ContactApiService, OptionSetsApiService } from '../../data-services';
import { DcaLicenseService } from '../../account/dca/dca-license.service';

@Component({
  selector: 'ebb-portal-dialog-ldpunlisted',
  templateUrl: './dialog-ldpunlisted.component.html',
  styles: []
})
export class DialogLdpUnlistedComponent implements OnInit {



  public formLicense: FormGroup;
  public formContact: FormGroup;
  public formMailing: FormGroup;
  public checkLicense = false;
  public invalidLicense = false;
  public invalidLicenseClassification = false;
  public invalidLicenseClassificationMsg = '';
  public invalidContactClassificationMsg= '';
  public isEmailExists: boolean = false;
  public disableSave = true;
  public disableNext1 = true;
  public disableNext2 = true;
  public disableLinear = true;
  public licensecheckdone = false;
  public isldpexists = false;
  public isExistldpData: IContact;
  public ldpLicenseSummary = '';
  public ldpContactInfoSummary = '';
  public ldpMailingAddressSummary = '';
  public ldplicensenumber: string;
  public  ldplicensetype: string;
  public ldplicenseexpdate: Date;
  public  ldpData: any;
  public licenseTypeOptions: IOptions[] = [];
  public ldpType: string;
  public contactOptions: IOptionSets[] = [];
  isEmailCheckInProgress: boolean = false;
  constructor(
    public readonly dialogRef: MatDialogRef<DialogLdpUnlistedComponent>,
    private readonly fb: FormBuilder,
    private readonly apidcaService: DcaLicenseService,
    private readonly apiContact: ContactApiService,
    private apiOptionSets: OptionSetsApiService,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    this.loadAppldpOptionsData();
    this.initializeForms();
  }
  private loadAppldpOptionsData(): void {
    this.apiOptionSets.getList('contact').subscribe(
      data => {
        this.contactOptions = data;
        const indexeventOptions = this.contactOptions.findIndex(
          i => i.name === 'cea_licensetypeldp'
        );
        this.licenseTypeOptions = [
          ...this.contactOptions[indexeventOptions].options
        ];
       
      },
      error => console.warn(error)
    );
  }
  private initializeForms() : void {
    this.formLicense = this.fb.group({
      licensenumber: ['', Validators.compose([Validators.required])],
      licensetype: ['', Validators.required]
    });

    this.formContact = this.fb.group({
      // businessName: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      emailAddress2: ['',
        [
          Validators.required,
          Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        ]
      ],
      telephone1: ['', [Validators.required]],
     
      
    });

    this.formMailing = this.fb.group({
      sameAsBusinessAddress: '',
      address3_Line1: ['', [Validators.required]],
      address3_Line2: '',
      address3_City: ['', [Validators.required]],
      address3_StateOrProvince: ['', [Validators.required]],
      address3_PostalCode: ['', [Validators.required]]
    });
  }
  private loadldpinfo() {
    if (this.ldpData) {
      this.formContact.get('firstName').setValue(this.ldpData.firstName);
      this.formContact.get('lastName').setValue(this.ldpData.lastName);
      this.formMailing.get('address3_Line1').setValue(this.ldpData.address1);
      this.formMailing.get('address3_City').setValue(this.ldpData.city);
      this.formMailing.get('address3_StateOrProvince').setValue(this.ldpData.state);
      this.formMailing.get('address3_PostalCode').setValue(this.ldpData.zipCode);
     
      this.ldplicensenumber=this.ldpData.licenseNumber;
      this.ldplicenseexpdate = this.ldpData.expirationDate;
      this.ldplicensetype = this.ldpData.licenseTypeDesc;
    }
  }
  public onLookupLicenseNumber(): void {
    const checkNumber = this.formLicense.get('licensenumber').value;
 

    const type = this.formLicense.get('licensetype').value;
    this.ldpType = type;
    let licenseType = 'C';
    
      switch (type)
      {
          case "700000000":
            licenseType = "C";
              break;
          case "700000001":
            licenseType = "S";
              break;
          case "700000002":
            licenseType = "AR";
              break;
      }
    


    this.checkLicense = true;
    this.ldpData = null;
    this.isExistldpData =null;
    this.isldpexists = false;
    this.invalidLicenseClassification = false;
          this.invalidLicenseClassificationMsg = "";
          this.apidcaService
          .getLdpLicense(checkNumber,licenseType)
          .subscribe(
            data => {
              //console.log(`Return: ${JSON.stringify(data)}`)
              const licenseIsValid = data.isValid;
              this.ldpData = data;
              if ( !licenseIsValid) {
                this.invalidLicense = true;
                this.checkLicense = false;
                this.invalidLicenseClassificationMsg = data.errormessage;
                this.disableNext1 = true;
                this.formContact.disable();
                this.formMailing.disable();
            
              }
              if ( licenseIsValid ) {
                
                  this.invalidLicense = false;
                  this.loadldpinfo();
                  this.formLicense.get('licensenumber').setValue(this.ldplicensenumber);
                  this.ldpLicenseSummary = `- ${this.ldpData.firstName} ${this.ldpData.lastName}`
                  this.setDefaultValues();
                  this.invalidLicenseClassification = false;
                  this.disableNext1 = false;
                  this.disableLinear = false;
                  this.disableSave = false;                 
                  this.apiContact.CheckLDPLicense(this.ldplicensenumber).subscribe(
                    existingLdpUsingLicense => {
              if(existingLdpUsingLicense == null){
                this.licensecheckdone = true;
                this.formContact.enable();
                this.formMailing.enable();
                } else {

                      this.isExistldpData =existingLdpUsingLicense;
                      this.ldpLicenseSummary = `- ${this.ldpData.fullName}`
                      this.isldpexists = true;
                      this.invalidLicense = true;
                      this.checkLicense = false;
                      this.disableNext1 = true;
                      this.licensecheckdone = false;
                      this.formContact.disable();
                      this.formMailing.disable();
                       }
                
                    }, error => {
                      console.warn(`ERROR: getCheckLicenseExists() or getContactExists() - ${error}`);
                    });
                  
                
                this.checkLicense = false;
              }
            },
          error => console.warn(`ERROR: Unable to validate license number`)
          );
    

   
  }

  public displayLicenseExpiration(): string {
    const newDateString = this.ldpData.expirationDate;
    const newDateOnly = new Date(newDateString); 
    return newDateOnly.toLocaleDateString('en-US');
  }

  private setDefaultValues(): void {
    if (this.ldpData.address2_Telephone1 &&
        this.ldpData.address2_Telephone1.length > 0) {
      this.formContact.get('telephone1').setValue(this.ldpData.address2_Telephone1);
    }
  }

  public setLdpContactInfoSummary(): void {
    const fullName = `${this.formContact.get('firstName').value} ${this.formContact.get('lastName').value}`;
    this.ldpContactInfoSummary = `- ${fullName}`;
    
  }
  onEmailChange(): void {
    const emailAddress1 = this.formContact.get('emailAddress2').value;
    this.isEmailCheckInProgress = true;  
    if(this.formContact.get('emailAddress2')?.valid){
    this.apiContact.CheckLdpContactExists(emailAddress1).subscribe(
      contact => {
        this.isEmailCheckInProgress = false;
        // Check if the contact exists with specific classifications
        if (
          contact.isEngineer === true ||
          contact.isHomeowner === true ||
          contact.isContractor === true
        ) {
          this.isEmailExists = true;
          this.invalidContactClassificationMsg =
            'Email address already in the system. Please contact EBB Customer Service: Email info@EarthquakeBraceBolt.com or Customer Service Number (877) 232-4300.';
          this.formMailing.disable();
          this.formContact.get('emailAddress2').markAsTouched();
        } else {
          this.isEmailExists = false;
          this.invalidContactClassificationMsg = '';
          this.formMailing.enable();
        }
      },
      error => {
        this.isEmailCheckInProgress = false;
        this.isEmailExists = false;
        this.invalidContactClassificationMsg = 'An error occurred. Please try again later.';
        this.formMailing.enable();
      }
    );}
  }
  
  public onCheckSameAsBusinessAddress(event): void {
    if(this.ldpData) {
      if (event.checked) {
        this.formMailing.get('address3_Line1').setValue(this.ldpData.address1);
        this.formMailing.get('address3_City').setValue(this.ldpData.city);
        this.formMailing.get('address3_StateOrProvince').setValue(this.ldpData.state);
        this.formMailing.get('address3_PostalCode').setValue(this.ldpData.zipCode);
        

        this.formMailing.get('address3_Line1').disable();
        this.formMailing.get('address3_Line2').disable();
        this.formMailing.get('address3_City').disable();
        this.formMailing.get('address3_StateOrProvince').disable();
        this.formMailing.get('address3_PostalCode').disable();


      } else {
        this.formMailing.get('address3_Line1').setValue('');
        this.formMailing.get('address3_Line2').setValue('');
        this.formMailing.get('address3_City').setValue('');
        this.formMailing.get('address3_StateOrProvince').setValue('');
        this.formMailing.get('address3_PostalCode').setValue('');
        this.formMailing.get('address3_Line1').enable();
        this.formMailing.get('address3_Line2').enable();
        this.formMailing.get('address3_City').enable();
        this.formMailing.get('address3_StateOrProvince').enable();
        this.formMailing.get('address3_PostalCode').enable();
      }
    }
  }

  public onCheckFormLicenseControlValidators(controlName: string): boolean {
    const retVal = (this.formLicense.get(controlName).errors
                      && (this.formLicense.get(controlName).dirty || this.formLicense.get(controlName).touched));
    return retVal;
  }

  public onCheckFormContactControlValidators(controlName: string): boolean {
    const retVal = (this.formContact.get(controlName).errors
                      && (this.formContact.get(controlName).dirty || this.formContact.get(controlName).touched));
    return retVal;
  }

  public onCheckFormMailingControlValidators(controlName: string): boolean {
    const retVal = (this.formMailing.get(controlName).errors
                      && (this.formMailing.get(controlName).dirty || this.formMailing.get(controlName).touched));
    return retVal;
  }

  public onCheckFormContactControlLengthHint(controlName: string, length: number): boolean {
    return this.formContact.get(controlName).value && this.formContact.get(controlName).value.length >= length;
  }

  public onCheckFormLicenseControlLengthHint(controlName: string, length: number): boolean {
    return this.formLicense.get(controlName).value && this.formLicense.get(controlName).value.length >= length;
  }

  public onCheckFormMailingControlLengthHint(controlName: string, length: number): boolean {
    return this.formMailing.get(controlName).value && this.formMailing.get(controlName).value.length >= length;
  }

  public onClickClose(): void {
    this.dialogRef.close();
  }
  public onExistingLdpSelect(): void{
     var data ={} as any;
    data.contact = this.isExistldpData;
    data.isexists = true;
    data.contactInput =null;
    this.dialogRef.close(data);
  }

  public onSave(): void {
    const newContact: IContactInput = {} as IContactInput;

    newContact.firstName = this.formContact.get('firstName').value;
    newContact.lastName = this.formContact.get('lastName').value;
    newContact.emailAddress1 = this.formContact.get('emailAddress2').value;
    newContact.telephone1 = this.formContact.get('telephone1').value;
    const type = this.formLicense.get('licensetype').value;
    newContact.ldpLicenseNumber = this.ldplicensenumber;
    
    newContact.ldpLicenseType = type.toString();
    newContact.ldpLicenseExpiration = this.ldplicenseexpdate;   
    newContact.ldpLicenseIsValid = true;
    newContact.ldpStatus = this.ldpData.licenseStatus

    // newContact.businessName = this.formContact.get('businessName').value;

    newContact.address2_Line1 = this.ldpData.address1;
   
    newContact.address2_City = this.ldpData.city;
    newContact.address2_StateOrProvince = this.ldpData.state;
    newContact.address2_PostalCode = this.ldpData.zipCode;
    var sameAsBusinessAddress = this.formMailing.get('sameAsBusinessAddress').value
    if(sameAsBusinessAddress ===true){
    newContact.isSameas_BusinessAddress =  sameAsBusinessAddress
  }
    newContact.address3_Line1 = this.formMailing.get('address3_Line1').value;
    newContact.address3_City = this.formMailing.get('address3_City').value;
    newContact.address3_StateOrProvince = this.formMailing.get('address3_StateOrProvince').value;
    newContact.address3_PostalCode = this.formMailing.get('address3_PostalCode').value;
    var data ={} as any;

    data.contact = null;
    data.isexists = false;
    data.contactInput =newContact;
    this.dialogRef.close(data);
  }
  public formatLink(value: string) {
    if (value) {
      value = value.toLowerCase();
      if (value.startsWith('http')) {
        return value;
      } else {
        return `http://${value}`;
      }
    }
    return '';
  }
}